export const ENUM = {
    route: {
        admin: "admin",
        articles: "articles",
        users: "users",
        brands: "brands",
        countries: "countries",
        categories: "categories",
        retailers: "retailers",
        market: "market",
    }
}
